import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Card, Button, Dialog, DialogTitle, List, ListItem, ListItemText } from '@material-ui/core';
import './Home.css';

// Firebase
import { firebaseSdk } from '../Firebase/Init';

// Components
import Header from '../Components/Header';
import CheckoutBar from '../Components/CheckoutBar';

// Dialog
function QuantityDialog(props) {
    const { onClose, selectedValue, open } = props;

    const handleClose = () => {
        onClose(selectedValue);
    }

    const handleListItemClick = (value) => {
        onClose(value);
    }

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>Quantity</DialogTitle>
            <List>
                <ListItem button onClick={() => handleListItemClick(1)}>
                    <ListItemText primary="1" />
                </ListItem>
                <ListItem button onClick={() => handleListItemClick(2)}>
                    <ListItemText primary="2" />
                </ListItem>
                <ListItem button onClick={() => handleListItemClick(3)}>
                    <ListItemText primary="3" />
                </ListItem>
                <ListItem button onClick={() => handleListItemClick(4)}>
                    <ListItemText primary="4" />
                </ListItem>
            </List>
        </Dialog>
    )
}

function Home() {
    const [menuItems, setMenuItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState();
    const [order, setOrder] = useState({});
    const [cart, setCart] = useState(JSON.parse(localStorage.getItem('cart') || '[]'));
    const [open, setOpen] = useState(false);
    const history = useHistory();

    // Init
    useEffect(() => {
        // Check auth
        checkAuthentication();

        // Get menu items
        getMenuItems();
        // eslint-disable-next-line
    }, []);

    // On order change
    useEffect(() => {
        const orderArray = Object.entries(order);
        if (orderArray.length > 0) {
            
            let finalOrderArray = [];
            for (const item of orderArray) {
                finalOrderArray.push({ name: menuItems[item[0]].name, quantity: item[1], price: menuItems[item[0]].price });
            };

            setCart(finalOrderArray);
        }
        // eslint-disable-next-line
    }, [order]);

    // Ensure user is logged in
    const checkAuthentication = () => {
        firebaseSdk.auth().onAuthStateChanged((user) => {
            // If user is not signed in redirect back to Login
            if (!user) {
                history.push('/Login');
            }
        })
    };

    // Get menu items
    const getMenuItems = () => {
        const menu = firebaseSdk.database().ref('/menu');

        // Set data when received
        menu.on('value', (snapshot) => {
            let menuItemArray = [];
            snapshot.forEach((childSnapshot) => {
                let childData = childSnapshot.val();
                menuItemArray.push(childData);
            });
            setMenuItems(menuItemArray);
        });
    }

    // On add button click and modal interactions
    const onAddBtnClick = (item) => {
        setSelectedItem(item);
        setOpen(true);
    }
    const handleClose = (value) => {
        // Set order
        setOrder({ ...order, [selectedItem.id]: value });

        setOpen(false);
    }

    // Checkout items
    const handleCheckout = () => {
        localStorage.setItem('cart', JSON.stringify(cart));
        history.push('/Checkout');
    }

    return (
        <div>
            <Header title="Menu" />
            <QuantityDialog selectedValue={0} open={open} onClose={handleClose}/>
            <div className="content-body padding-2x padding-2y">
                {
                    menuItems.map((item, index) => {
                        return (
                            <Card key={index} className="margin-2y padding-2x padding-2y">
                                <Grid container>
                                    <Grid item xs={6}>
                                        {item.name} - ${item.price}
                                    </Grid>
                                    <Grid item xs={6} className="text-right">
                                        <Button variant="contained" color="primary" onClick={() => onAddBtnClick(item)}>Add</Button>
                                    </Grid>
                                </Grid>
                            </Card>
                        )
                    })
                }
            </div>
            { cart.length > 0 && <CheckoutBar onCheckout={handleCheckout}/> }
        </div>
    )
}

export default Home;